import {useCallback} from 'react';
import {UseFormGetValues} from 'react-hook-form';
import {IFormStepOne} from 'src/components/common/styled/FormStepOne';
import {useFAContext} from 'src/components/providers/facebookAds';
import {ClientBusinessTypeKey} from 'src/enums/BusinessType';
import {Step} from 'src/enums/facebook/Step';
import {IUserDetails} from 'src/types/common/UserDetails';
import {Logger} from 'src/utils/Logger';

type ReturnType = {
  onSubmit: () => void;
}

export const useSubmit = (getValues: UseFormGetValues<IFormStepOne>): ReturnType => {
  const context = useFAContext();

  const onSubmit = useCallback(() => {
    const userDetails = ['firstName', 'lastName', 'phoneNumber', 'businessType'].reduce(
      (result, fieldName) => {
        const fieldValue = getValues(fieldName as keyof IFormStepOne);
        if (fieldName === 'businessType' && fieldValue) {
          const isClient = getValues(fieldName as keyof IFormStepOne) === ClientBusinessTypeKey;
          return {
            ...result,
            isClient
          };
        }
        return {
          ...result,
          [fieldName]: fieldValue
        };
      },
      {}
    ) as IUserDetails;
    Logger.trace('onSubmit:userDetails', {userDetails}, 'FormStepOne');
    context.setUserDetails({...userDetails});
    context.setCurrentStep(Step.FILL_BUSINESS_INFO);
  }, [context, getValues]);

  return {onSubmit};
};
